// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .sc-grid-no-m {
  margin: 0;
}
::ng-deep .p-col-24 {
  flex: 0 0 auto;
  padding: 0.5rem;
}
::ng-deep .p-col-24 {
  width: 20%;
}
::ng-deep .p-col-24.column {
  border-left: 1px solid #eee;
}
::ng-deep .p-col-24.column:last-child {
  border-right: 1px solid #eee;
}
::ng-deep .submenu .column-menu {
  padding: 0 1rem;
  /*margin: 0 0 2rem;*/
  min-height: 158px;
}
::ng-deep .submenu .column-menu .column-heading {
  margin-bottom: 0.5rem;
}
::ng-deep .submenu .column-menu .column-heading span {
  /*color: #023048;*/
  color: var(--accent);
  padding: 0 0 0.25rem 1rem;
  font-weight: 500;
  text-transform: uppercase;
}
::ng-deep .submenu .column-menu .a-dummy {
  height: 24px;
}
::ng-deep .submenu .column-menu a, ::ng-deep .submenu .column-menu a:not([href]):not([class]) {
  float: none;
  color: var(--dark-3);
  padding: 0 0 0.25rem 1rem;
  text-decoration: none;
  display: block;
  text-align: left;
}
::ng-deep .submenu .column-menu a:hover, ::ng-deep .submenu .column-menu a:not([href]):not([class]):hover {
  color: var(--dark-2);
  background-color: transparent;
}
::ng-deep .submenu .column-product .product-image {
  text-align: center;
}
::ng-deep .submenu .column-product .product-image img {
  width: 100%;
}
::ng-deep .submenu .column-product .product-image .product-label {
  height: 22px;
  overflow: hidden;
  font-size: smaller;
  padding-left: 0;
  color: var(--dark-3);
  text-align: center;
  text-transform: uppercase;
}
::ng-deep .submenu .column-product .product-image .product-price {
  padding-left: 0;
  text-align: center;
  color: var(--primary);
  font-size: x-large;
}

@media (max-width: 640px) {
  ::ng-deep .submenu .submenu-column {
    margin-bottom: 1rem;
  }
  ::ng-deep .submenu .submenu-column .column-product .product-image .product-price {
    font-size: large;
  }
}
@media (max-width: 1280px) {
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu {
    padding: 16px 0;
  }
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .submenu-column {
    margin-bottom: 1rem !important;
  }
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container {
    padding: 0;
    max-width: calc(100vw - 32px);
  }
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container .p-col-24.column .column-menu {
    padding: 0;
  }
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container .p-col-24.column .column-menu .column-heading span {
    padding-left: 0;
  }
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container .p-col-24.column .column-menu a, ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container .p-col-24.column .column-menu a:not([href]):not([class]) {
    padding-left: 0;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 1281px) and (max-width: 1399px) {
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container .p-col-24.column .column-menu {
    padding: 0;
    min-height: unset;
  }
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container .p-col-24.column .column-menu .column-heading span {
    padding-left: 1rem;
  }
  ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container .p-col-24.column .column-menu a, ::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .container .p-col-24.column .column-menu a:not([href]):not([class]) {
    padding-left: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/navigation/v3.0/mm.submenu.scss"],"names":[],"mappings":"AACC;EACC,SAAA;AAAF;AAGC;EAGC,cAAA;EACA,eAAA;AADF;AAIC;EACC,UAAA;AAFF;AAIE;EACC,2BAAA;AAFH;AAIG;EACC,4BAAA;AAFJ;AAQE;EACC,eAAA;EACA,oBAAA;EACA,iBAAA;AANH;AAQG;EAQC,qBAAA;AAbJ;AAMI;EACC,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAJL;AASG;EACC,YAAA;AAPJ;AAUG;EACC,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AARJ;AAWG;EACC,oBAAA;EACA,6BAAA;AATJ;AAcG;EACC,kBAAA;AAZJ;AAcI;EACC,WAAA;AAZL;AAeI;EACC,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;AAbL;AAgBI;EACC,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAdL;;AAqBA;EAGG;IACC,mBAAA;EApBF;EAwBI;IACC,gBAAA;EAtBL;AACF;AA8BA;EAGG;IACC,eAAA;EA9BF;EAgCE;IACC,8BAAA;EA9BH;EAiCE;IACC,UAAA;IACA,6BAAA;EA/BH;EAkCI;IACC,UAAA;EAhCL;EAkCK;IACC,eAAA;EAhCN;EAmCK;IACC,eAAA;EAjCN;AACF;AA0CA,mDAAA;AACA;EAGG;IACC,UAAA;IACA,iBAAA;EA1CF;EA4CE;IACC,kBAAA;EA1CH;EA6CE;IACC,kBAAA;EA3CH;AACF","sourcesContent":["::ng-deep {\n\t.sc-grid-no-m {\n\t\tmargin: 0;\n\t}\n\n\t.p-col-24 {\n\t\t-webkit-box-flex: 0;\n\t\t-ms-flex: 0 0 auto;\n\t\tflex: 0 0 auto;\n\t\tpadding: 0.5rem;\n\t}\n\n\t.p-col-24 {\n\t\twidth: 20%;\n\n\t\t&.column {\n\t\t\tborder-left: 1px solid #eee;\n\n\t\t\t&:last-child {\n\t\t\t\tborder-right: 1px solid #eee;\n\t\t\t}\n\t\t}\n\t}\n\n\t.submenu {\n\t\t.column-menu {\n\t\t\tpadding: 0 1rem;\n\t\t\t/*margin: 0 0 2rem;*/\n\t\t\tmin-height: 158px;\n\n\t\t\t.column-heading {\n\t\t\t\tspan {\n\t\t\t\t\t/*color: #023048;*/\n\t\t\t\t\tcolor: var(--accent);\n\t\t\t\t\tpadding: 0 0 .25rem 1rem;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t}\n\t\t\t\tmargin-bottom: .5rem;\n\t\t\t}\n\n\t\t\t.a-dummy {\n\t\t\t\theight: 24px;\n\t\t\t}\n\n\t\t\ta, a:not([href]):not([class]) {\n\t\t\t\tfloat: none;\n\t\t\t\tcolor: var(--dark-3);\n\t\t\t\tpadding: 0 0 .25rem 1rem;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tdisplay: block;\n\t\t\t\ttext-align: left;\n\t\t\t}\n\n\t\t\ta:hover, a:not([href]):not([class]):hover {\n\t\t\t\tcolor: var(--dark-2);\n\t\t\t\tbackground-color: transparent;\n\t\t\t}\n\t\t}\n\n\t\t.column-product {\n\t\t\t.product-image {\n\t\t\t\ttext-align: center;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\n\t\t\t\t.product-label {\n\t\t\t\t\theight: 22px;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\tfont-size: smaller;\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tcolor: var(--dark-3);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t}\n\n\t\t\t\t.product-price {\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tcolor: var(--primary);\n\t\t\t\t\tfont-size: x-large;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 640px) {\n\t::ng-deep {\n\t\t.submenu {\n\t\t\t.submenu-column {\n\t\t\t\tmargin-bottom: 1rem;\n\n\t\t\t\t.column-product {\n\t\t\t\t\t.product-image {\n\t\t\t\t\t\t.product-price {\n\t\t\t\t\t\t\tfont-size: large;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 1280px) {\n\t::ng-deep {\n\t\t.mega-menu-container .mega-menu .submenu-container {\n\t\t\t.submenu {\n\t\t\t\tpadding: 16px 0;\n\n\t\t\t\t.submenu-column {\n\t\t\t\t\tmargin-bottom: 1rem !important;\n\t\t\t\t}\n\n\t\t\t\t.container {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmax-width: calc(100vw - 32px);\n\n\t\t\t\t\t.p-col-24.column {\n\t\t\t\t\t\t.column-menu {\n\t\t\t\t\t\t\tpadding: 0;\n\n\t\t\t\t\t\t\t.column-heading span {\n\t\t\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\ta, a:not([href]):not([class]) {\n\t\t\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 1281px) and (max-width: 1399px) {\n\t::ng-deep {\n\t\t.mega-menu-container .mega-menu .submenu-container .submenu .container {\n\t\t\t.p-col-24.column .column-menu {\n\t\t\t\tpadding: 0;\n\t\t\t\tmin-height: unset;\n\n\t\t\t\t.column-heading span {\n\t\t\t\t\tpadding-left: 1rem;\n\t\t\t\t}\n\n\t\t\t\ta, a:not([href]):not([class]) {\n\t\t\t\t\tpadding-left: 1rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
